import { errorMessage } from "helpers/utils";
import { useTranslation } from "react-i18next";
import { useMutation, useQuery } from "react-query";
import { useToasts } from "react-toast-notifications";
import locationService from "services/locationService";
import { formConvertErrorMessage } from "../../helpers/form_helper";

// Create Shipping Unit
export const useCreateLocation = (onSuccess, onError) => {
  const { addToast } = useToasts();

  return useMutation(locationService.createLocation, {
    retry: 0,
    onSuccess: data => {
      if (typeof onSuccess === "function") {
        onSuccess(data);
      }
    },
    onError: error => {
      const errorResponse = errorMessage(error);

      if (errorResponse?.code === 422 && errorResponse?.fields?.length > 0) {
        errorResponse.fields.forEach(item => {
          switch (item.field) {
            default:
              addToast(item.message, {
                appearance: "error",
                autoDismiss: true,
                autoDismissTimeout: 10000,
              });
              break;
          }
        });
      }

      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
  });
};

export const useUpdateLocation = (onSuccess, onError) => {
  return useMutation(locationService.updateLocation, {
    retry: 0,
    onSuccess: data => {
      if (typeof onSuccess === "function") {
        onSuccess(data);
      }
    },
    onError: error => {
      const errorResponse = errorMessage(error);
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
  });
};

export const useDeleteLocation = (onSuccess, onError) => {
  return useMutation(locationService.deleteLocation, {
    retry: 0,
    onSuccess: data => {
      if (typeof onSuccess === "function") {
        onSuccess(data);
      }
    },
    onError: error => {
      const errorResponse = errorMessage(error);
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
  });
};

export const useListLocation = (payload, onSuccess, onError) => {
  const { addToast } = useToasts();
  const { t } = useTranslation();

  return useQuery(
    ["locations", payload?.params],
    () => locationService.geListLocation(payload),
    {
      enabled: false,
      retry: 1,
      refetchOnWindowFocus: false,
      onSuccess,
      onError: error => {
        const errorResponse = errorMessage(error);
        addToast(
          formConvertErrorMessage(
            errorResponse.message ||
              t("message.fetch_profile", {
                status: t("message.error"),
              }),
            t
          ),
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
        if (typeof onError === "function") {
          onError(errorResponse);
        }
      },
      // initialData: [],
      select: response => {
        const { data } = response;

        return {
          items: data?.items || [],
        };
      },
    }
  );
};
